import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import compose from "recompose/compose";
import withWidth from "@material-ui/core/withWidth";
import Hidden from "@material-ui/core/Hidden";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Typography from "@material-ui/core/Typography";

// eslint-disable-next-line no-unused-vars
const styles = (theme) => ({
  stepper: {},
});

class ResponsiveStepper extends Component {
  render() {
    const { classes, steps, activeStep } = this.props;

    //Do not display on step 0, the intro page
    if (activeStep === 0) {
      return null;
    }

    return (
      <Hidden smDown>
        <Stepper
          activeStep={steps[activeStep].stepNumber}
          className={classes.stepper}
        >
          {
            // eslint-disable-next-line no-unused-vars
            steps.map((step, index) => {
              const stepProps = {};
              const labelProps = {};
              if (step.isOptional) {
                labelProps.optional = (
                  <Typography variant="caption">Optional</Typography>
                );
              }
              if (step.displayInStepper) {
                return (
                  <Step key={step.title} {...stepProps}>
                    <StepLabel {...labelProps}>{step.title}</StepLabel>
                  </Step>
                );
              } else {
                return null;
              }
            })
          }
        </Stepper>
      </Hidden>
    );
  }
}

ResponsiveStepper.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default compose(withStyles(styles), withWidth())(ResponsiveStepper);
